import { useState } from 'react'

import Button from 'components/atoms/Button'

const CarJson = ({ data = [], loading = false }) => {
  const [copied, setCopied] = useState(false)

  const handleCopy = () => {
    navigator.clipboard.writeText(JSON.stringify(data, null, 2))
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  return (
    <div className="p-2 bg-white rounded-lg shadow-lg max-h-[80vh] overflow-y-auto">
      <div className="flex justify-between items-center mb-4">{data.length > 0 && <Button onClick={handleCopy}>{copied ? 'Copied' : 'Copy JSON'}</Button>}</div>

      {loading ? <p>Loading...</p> : <pre className="bg-gray-100 p-4 rounded-lg text-sm overflow-x-auto whitespace-pre-wrap">{JSON.stringify(data, null, 2)}</pre>}
    </div>
  )
}

export default CarJson
